import { useTranslations } from 'next-intl';
import { GlowIcon, GlowTextBody, GlowTitle, Icons } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

export const NoStoreFound: Component = () => {
    const t = useTranslations('Modal.stores.error.noStoreFound');

    return (
        <div className={'flex flex-col gap-1.5 px-1 py-2.5'}>
            <GlowIcon Icon={Icons.ErrorSearch} type={'xxxLarge'} className={'mx-auto'} />
            <div className={'flex flex-col gap-1'}>
                <GlowTitle text={t('title')} fontSize={'title4'} />
                <GlowTextBody text={t('description')} />
            </div>
        </div>
    );
};
